module.exports = __webpack_public_path__ + "static/images/components/UpgradeIcon/images/arrow-1.0cf7e126.png";


//////////////////
// WEBPACK FOOTER
// ./components/UpgradeIcon/images/arrow-1.png
// module id = 2696
// module chunks = 11